"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _StoredCards = _interopRequireDefault(require("./StoredCards"));
var _contexts = require("../../../contexts");
var _Input = _interopRequireDefault(require("../../fields/Input"));
var _Icon = _interopRequireDefault(require("../../icons/Icon"));
var _nativePaymentPropsGenerator = require("../../../utils/native-payment/nativePaymentPropsGenerator");
var _iconUtils = require("../../icons/iconUtils");
var _nativePaymentUtils = require("../../../utils/native-payment/nativePaymentUtils");
var _fields = require("../../fields");
var _config = require("../../../i18n/config");
var _address = require("../../../core/services/address");
var _commonUtils = require("../../../utils/commonUtils");
var _paymentMethodMessages = require("../../paymentAccordion/paymentMethodMessages");
var _constants = require("../../../constants/constants");
var _BillingAddressContainer = _interopRequireDefault(require("../../BillingAddressContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NativeWidget = function NativeWidget(props) {
  var _props$block = props.block,
    inputCustomData = _props$block.inputCustomData,
    paymentInfo = _props$block.paymentInfo,
    setPaymentInfo = _props$block.setPaymentInfo,
    onAddressChange = _props$block.customFunctions.onAddressChange;
  var _useState = (0, _react.useState)(-1),
    _useState2 = _slicedToArray(_useState, 2),
    selectedStoredCardIndex = _useState2[0],
    setSelectedStoredCardIndex = _useState2[1];
  var _inputCustomData$cart = inputCustomData.cart,
    _inputCustomData$cart2 = _inputCustomData$cart.languageCode,
    languageCode = _inputCustomData$cart2 === void 0 ? _config.FALLBACK_LOCALE : _inputCustomData$cart2,
    _inputCustomData$cart3 = _inputCustomData$cart.stateCode,
    stateCode = _inputCustomData$cart3 === void 0 ? {} : _inputCustomData$cart3,
    userDetails = inputCustomData.userDetails;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var _useContext = (0, _react.useContext)(_contexts.NativeContext),
    nativeDispatch = _useContext.dispatch,
    _useContext$state = _useContext.state,
    paymentMethodDetails = _useContext$state.paymentMethodDetails,
    statesResponse = _useContext$state.statesResponse;
  var CardTypes = paymentMethodDetails.cardTypes.map(function (cardType) {
    return (0, _iconUtils.getCardNumberIcon)(cardType);
  });
  var storedCards = paymentMethodDetails.storedPaymentMethods;
  var countryCodes = paymentMethodDetails.billingCountyCodes,
    enableStoreCardInfo = paymentMethodDetails.enableStoreCardInfo,
    enablePaymentPlusTokenization = paymentMethodDetails.enablePaymentPlusTokenization,
    widgetNameOrder = paymentMethodDetails.widgetNameOrder;
  var country = paymentInfo.country,
    billingContainerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!(0, _commonUtils.isEmptyString)(country.value)) {
      (0, _address.getStatesForCountry)(country.value, languageCode, nativeDispatch, setStateValue, stateCode);
    }
  }, [country === null || country === void 0 ? void 0 : country.value]);
  var handleChange = function handleChange(updatedPaymentInfo, eventType) {
      var _updatedPaymentInfoOb;
      var _getCountryProps = (0, _nativePaymentPropsGenerator.getCountryProps)(formatMessage),
        countryKey = _getCountryProps.name,
        updatedPaymentInfoObj = _objectSpread(_objectSpread({}, paymentInfo), updatedPaymentInfo);
      // If there is a change in country field, refresh the state field
      if (Object.prototype.hasOwnProperty.call(updatedPaymentInfo, countryKey)) {
        var _getStateProps = (0, _nativePaymentPropsGenerator.getStateProps)()(formatMessage),
          stateKey = _getStateProps.name;
        var InitialState = (0, _nativePaymentUtils.getInitialState)();
        setPaymentInfo(_objectSpread(_objectSpread({}, updatedPaymentInfoObj), {}, _defineProperty({}, stateKey, InitialState[stateKey])));
      } else {
        setPaymentInfo(_objectSpread({}, updatedPaymentInfoObj));
      }
      // Can be updated for for all fields, currently only updated for zipCode
      // This format can be extended to other fields as well
      if (eventType == 'blur' && updatedPaymentInfoObj !== null && updatedPaymentInfoObj !== void 0 && (_updatedPaymentInfoOb = updatedPaymentInfoObj.zipCode) !== null && _updatedPaymentInfoOb !== void 0 && _updatedPaymentInfoOb.value) {
        if (updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.country || updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.zipCode || updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.addressLine || updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.addressLineTwo || updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.city || updatedPaymentInfo !== null && updatedPaymentInfo !== void 0 && updatedPaymentInfo.state) {
          var addressObj = {};
          for (var addressKey in updatedPaymentInfoObj) {
            var _updatedPaymentInfoOb2;
            addressObj[addressKey] = ((_updatedPaymentInfoOb2 = updatedPaymentInfoObj[addressKey]) === null || _updatedPaymentInfoOb2 === void 0 ? void 0 : _updatedPaymentInfoOb2.value) || '';
          }
          var _country = addressObj.country,
            zipCode = addressObj.zipCode,
            addressLine = addressObj.addressLine,
            addressLineTwo = addressObj.addressLineTwo,
            city = addressObj.city,
            state = addressObj.state,
            updatedfieldName = Object.keys(updatedPaymentInfo)[0],
            updatedFieldValue = updatedPaymentInfo[Object.keys(updatedPaymentInfo)[0]].value,
            billingAddress = {
              address: {
                country: _country,
                zipCode: zipCode,
                addressLine: addressLine,
                addressLineTwo: addressLineTwo,
                city: city,
                state: state
              },
              updatedfield: _defineProperty({}, updatedfieldName, updatedFieldValue)
            };
          onAddressChange(_defineProperty({}, updatedfieldName, updatedFieldValue));
        }
      }
    },
    setStateValue = function setStateValue() {
      var statesObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (statesObj && Object.keys(statesObj).length == 1) {
        var stateKeys = Object.keys(statesObj),
          firstState = stateKeys.length ? stateKeys[0] : '',
          changedDetails = {
            state: {
              error: '',
              value: firstState
            }
          },
          zipcodeObj = paymentInfo && (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.zipCode) || {},
          zipCodeObj = _objectSpread({}, zipcodeObj);
        if (zipCodeObj.value !== '') {
          zipCodeObj.value = '';
          changedDetails.zipCode = zipCodeObj;
        }
        firstState && handleChange(changedDetails, 'blur');
      }
    };
  var onClickNewCreditCard = function onClickNewCreditCard() {
    setSelectedStoredCardIndex(-1);
    setPaymentInfo(_objectSpread(_objectSpread({}, paymentInfo), {}, {
      storedPaymentMethodId: '',
      storedCardCVV: {
        value: '',
        error: ''
      },
      isStoredCard: false
    }));
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "payment-accordion",
    id: "credit-card-accordion"
  }, !!storedCards && (storedCards === null || storedCards === void 0 ? void 0 : storedCards.length) > 0 && /*#__PURE__*/_react.default.createElement(_StoredCards.default, {
    paymentInfo: paymentInfo,
    setPaymentInfo: setPaymentInfo,
    storedCards: storedCards,
    selectedStoredCardIndex: selectedStoredCardIndex,
    setSelectedStoredCardIndex: setSelectedStoredCardIndex,
    handleChange: handleChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "new-credit-card-body-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-checkout__new-credit-card-header__title",
    id: "new-credit-card-header",
    onClick: function onClick() {
      return onClickNewCreditCard();
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: 'payment-checkout__payment-method__radio ',
    checked: selectedStoredCardIndex === -1,
    onChange: function onChange() {},
    id: 'newNativeCreditCard',
    value: formatMessage(_paymentMethodMessages.paymentMethodLabels[_constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD]),
    name: "nativeCardOption",
    type: "radio"
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: (0, _iconUtils.getPaymentMethodIconSource)(_constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD),
    className: "payment-checkout__new-credit-card__icon-wrapper"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "payment-checkout__new-credit-card__name ",
    htmlFor: "newNativeCreditCard"
  }, formatMessage(_paymentMethodMessages.paymentMethodLabels[_constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD]))), /*#__PURE__*/_react.default.createElement("div", {
    className: "my8"
  }, CardTypes), selectedStoredCardIndex === -1 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardNumber, (0, _nativePaymentPropsGenerator.getCardNumberProps)(formatMessage), {
    icon: (0, _iconUtils.getCardNumberIcon)((0, _nativePaymentUtils.getCardType)(paymentInfo.cardNumber.value)),
    customProps: {
      cardTypes: paymentMethodDetails.cardTypes
    },
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-details__container"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardExpiry, (0, _nativePaymentPropsGenerator.getCardExpiryProps)(formatMessage, 'cardExpiry'), {
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, paymentInfo.cardCVV, (0, _nativePaymentPropsGenerator.getCardCVVProps)(formatMessage, 'cardCVV'), {
    onChange: handleChange
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__card-holder-name__container"
  }, /*#__PURE__*/_react.default.createElement(_fields.NameOnCard, {
    nameOrder: widgetNameOrder,
    customProps: {
      firstName: paymentInfo.firstName.value,
      lastName: paymentInfo.lastName.value,
      fullName: paymentInfo.fullName.value
    },
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_BillingAddressContainer.default, {
    billingInfo: paymentInfo,
    languageCode: languageCode,
    countryCodes: countryCodes,
    onChange: handleChange,
    statesResponse: statesResponse,
    billingContainerRef: billingContainerRef
  }), (enableStoreCardInfo || enablePaymentPlusTokenization) && !!(userDetails && userDetails.isLoggedIn) && /*#__PURE__*/_react.default.createElement(_fields.SaveCardCheckbox, {
    paymentInfo: paymentInfo,
    setPaymentInfo: setPaymentInfo
  }))));
};
NativeWidget.propTypes = {
  block: _propTypes.default.object,
  customAuthCallBack: _propTypes.default.func,
  inputCustomData: _propTypes.default.object,
  payment: _propTypes.default.object,
  paymentInfo: _propTypes.default.object,
  setPaymentInfo: _propTypes.default.func,
  setProcessing: _propTypes.default.func
};
var _default = NativeWidget;
exports.default = _default;